import { fromResponse } from '@api/types'

import { commonApplicationClient } from '../../api/clients/common-application-client'
import { payFormService } from '../../service/payform'
import { SESSION_PRODUCT_KEY } from '../payform/payForm'

export interface TApplicationState {
  applicationId: string
}

export interface ApplicationReducerAction {
  action: ApplicationReducerActions
  applicationId: string
}

export enum ApplicationReducerActions {
  GET,
}

export const applicationReducer = (
  state: TApplicationState,
  action: ApplicationReducerAction,
) => {
  if (action.action === ApplicationReducerActions.GET) {
    if (!action.applicationId) return state
    if (state.applicationId === action.applicationId) return state
    commonApplicationClient.application(action.applicationId).then((res) => {
      const application = fromResponse(res)
      payFormService.initPayForm(application)
      sessionStorage.setItem(SESSION_PRODUCT_KEY, application.product)
    })
    return { applicationId: action.applicationId }
  }
  return { applicationId: '' }
}
